import Icon from 'veui/components/Icon'

Icon.register({
  'location-pin': {
    paths: [
      {
        d: 'M730.71 689.62A32 32 0 01704 704H64a32 32 0 01-29.41-44.61l96-224A32 32 0 01160 416h96a32 32 0 010 64h-74.9l-68.57 160h542.94L586.9 480H513a32 32 0 010-64h95a32 32 0 0129.41 19.39l96 224a32 32 0 01-2.7 30.23zM224 192c0-88.22 71.78-160 160-160s160 71.78 160 160c0 77.27-55.06 141.92-128 156.78V512a32 32 0 01-64 0V348.78C279.06 333.92 224 269.27 224 192zm64 0a96 96 0 1096-96 96.11 96.11 0 00-96 96z'
      }
    ],
    width: '768',
    height: '768'
  }
})
